import { Pipe, PipeTransform } from '@angular/core';

import { KPI } from '../../@core/api';

@Pipe({
    name: 'ngxInvestmentLocation',
    standalone: true
})
export class InvestmentLocationPipe implements PipeTransform {

  transform(investment: KPI.MappedInvestment): string {
    if (investment) {
      const parts: string[] = [];

      if (investment.site_name != null) {
        parts.push(investment.site_name);
      }

      if (investment.perimeters_names_list) {
        parts.push(investment.perimeters_names_list);
      }

      /* if (investment.asset_object && investment.asset_object.label) {
        parts.push(investment.asset_object.label);
      } */

      return parts.join(' > ');
    }
  }
}
